import { FC } from 'react';
import { AdvancedFiltersContainer } from 'shared/containers/AdvancedFiltersContainer';
import { BedroomsContainer } from 'shared/containers/BedroomsContainer';
import { BedsContainer } from 'shared/containers/BedsContainer';
import { DatesContainer } from 'shared/containers/DatesContainer';
import { DealTypeContainer } from 'shared/containers/DealTypeContainer';
import { EarlyAccessContainer } from 'shared/containers/EalryAccessContainer';
import { GeoSuggestContainer } from 'shared/containers/GeoSuggestContainer';
import { OfferTypeContainer } from 'shared/containers/OfferTypeContainer';
import { PriceContainer } from 'shared/containers/PriceContainer';
import { RoomTypeContainer } from 'shared/containers/RoomTypeContainer';
import { StarRatingContainer } from 'shared/containers/StarRatingContainer';
import { SuburbanAreaContainer } from 'shared/containers/SuburbanAreaContainer';
import { TFilter } from 'shared/types/filters';

export const FILTERS_MAP: Record<TFilter, FC> = {
  dealType: DealTypeContainer,
  offerType: OfferTypeContainer,
  bedrooms: BedroomsContainer,
  beds: BedsContainer,
  dates: DatesContainer,
  geo: GeoSuggestContainer,
  price: PriceContainer,
  roomType: RoomTypeContainer,
  suburbanArea: SuburbanAreaContainer,
  starRating: StarRatingContainer,
  advancedFilters: AdvancedFiltersContainer,
  earlyAccess: EarlyAccessContainer,
};
